import { useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'

export const initialValues = {
  email: '',
}

const useShareForm = () => {
  const { t } = useTranslation()
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string()
          .email(t('ERROR.E000004'))
          .max(
            100,
            t('ERROR.E000002', {
              field: t('SYSCOMMON.email'),
              character: 100,
            })
          )
          .required(
            t('ERROR.E000001', {
              field: t('SYSCOMMON.email'),
            })
          ),
      }),
    []
  )

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
    mode: 'onChange',
  })

  return { Controller, methods, initialValues }
}

export default useShareForm
